export const DIRECTUS_INSTANCE =
  process.env.REACT_APP_DIRECTUS_INSTANCE || 'https://api.paqshot.com';

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
export const BILLING_API_URL = process.env.REACT_APP_BILLING_API_URL || 'http://localhost:4010';
export const BILLING_DEFAULT_CURRENCY = process.env.REACT_APP_BILLING_DEFAULT_CURRENCY || 'usd';
// Legacy fallback price IDs (kept for backward compatibility while rolling out dynamic billing catalog).
export const STRIPE_TOPUP_PRICE_100 = process.env.REACT_APP_STRIPE_TOPUP_PRICE_100 || '';
export const STRIPE_TOPUP_PRICE_500 = process.env.REACT_APP_STRIPE_TOPUP_PRICE_500 || '';
export const STRIPE_SUBSCRIPTION_PRICE_STARTER = process.env.REACT_APP_STRIPE_SUBSCRIPTION_PRICE_STARTER || '';
export const STRIPE_SUBSCRIPTION_PRICE_GROWTH = process.env.REACT_APP_STRIPE_SUBSCRIPTION_PRICE_GROWTH || '';
export const STRIPE_SUBSCRIPTION_PRICE_SCALE = process.env.REACT_APP_STRIPE_SUBSCRIPTION_PRICE_SCALE || '';
export const STRIPE_BILLING_LOGIN_URL =
  process.env.REACT_APP_STRIPE_BILLING_LOGIN_URL || 'https://billing.stripe.com/p/login/test_cNi9AU14Z7zT8R6bwOg3600';

/** Base URL for image URLs and auth redirects */
export const BASE_URL =
  typeof window !== 'undefined' ? window.location.origin : '';

